"use strict";
var Model = require("../types/Model.js");

module.exports = Model({
	name: "careplan",
	init: init,
	triggers: triggers,
	listeners: listeners,

	_section: null,
	_proposals: [],
});

function init() {
	this.push({
		overlay: {},
		section: "",
		showDetail: ""
	});
}

function triggers() {
	return {
		view: view,
		reset: reset,
		showdetail: handle_showdetail,
		hidedetail: handle_hidedetail
	};
}

function listeners() {
	return {
		"careplanoverlay:updated": handle_overlay_updated,
		"atouchawaysettings:updated": handle_settings_update
	};
}

function view(data) {
	var section = data.section;

	this.extend({
		section: section
	});

	this.dispatch("viewing", data);
	this.emit("careplansection:trigger:view", data);
	this.emit("careplanproposedchanges:trigger:view", data);
}


function reset() {
	this.extend({
		section: "",
	});

	this.emit("careplansection:trigger:reset");
	this.emit("careplanproposedchanges:trigger:reset");
}

function handle_overlay_updated(overlay) {
	this.extend({
		overlay: overlay
	});
}

function handle_settings_update(settings){
	var currentSection = this.data.section;

	if (settings.careplan_sections && currentSection && (!settings.careplan_sections[currentSection]))
		this.emit("atouchawaymobile:trigger:page", {
			page: "careplan"
		});
}

function handle_showdetail(data){
	this.showdetail = data.section;
	this.extend({
		showDetail: data.section
	});
}

function handle_hidedetail(){
	this.showDetail = "";
	this.extend({
		showDetail: ""
	});
}
